import React, { useState, useEffect } from 'react'
import { Row, Col } from 'antd'
import { translate } from 'i18n'
import TKeys from 'i18n/translationKey'
import CheckAsOptions from './CheckAsOptions'
import { UnitItem } from 'features/filter/types'
import { SearchInput } from '../Form'
import { cloneDeep } from 'lodash'
import { hasText } from 'utils/getText'

interface Props {
  filter: any[]
  onChange(filter: any[]): void
  units: UnitItem[]
  useOnlyName?: boolean
  hasSearch?: boolean
}

const UnitContent: React.FunctionComponent<Props> = ({
  filter,
  onChange,
  units,
  useOnlyName = true,
  hasSearch = true,
}) => {
  const [textSearch, setTextsearch] = useState('')
  const [dataFilter, setDataFilter] = useState([] as UnitItem[])
  console.log(filter)
  useEffect(() => {
    setDataFilter(cloneDeep(units))
  }, [hasSearch, units])

  useEffect(() => {
    if (!hasSearch) return
    const list = cloneDeep(units)
    let filter = []
    if (textSearch === '') {
      filter = list
    } else {
      filter = list.filter(item => hasText(item.Unit, textSearch))
    }

    setDataFilter(filter)
  }, [textSearch])

  const onValueChange = (val: any) => {
    const index = filter.findIndex(item => item === val)
    if (index >= 0) {
      filter.splice(index, 1)
    } else {
      filter.push(val)
    }
    onChange(filter)
  }

  const onClear = () => {
    filter = []
    onChange(filter)
  }

  const content = () => {
    return dataFilter.map((item, index) => {
      let findIndex = filter.findIndex(it => it == item.Unit)
      if (!useOnlyName) {
        findIndex = filter.findIndex(it => it == item)
      }
      return (
        <Col span={24} key={index}>
          <CheckAsOptions
            key={item.Unit}
            title={item.Unit}
            value={findIndex >= 0}
            item={useOnlyName ? item.Unit : item}
            onChange={onValueChange}
          />
        </Col>
      )
    })
  }

  const clearBtn =
    filter.length > 0 ? (
      <span onClick={onClear} className="filter-clear std-font-regular">
        {translate(TKeys.Common.cancel_all)}
      </span>
    ) : (
      undefined
    )
  return (
    <div className="std-font-regular" style={css.page}>
      <Row>
        <Col span={24}>
          <div className="std-font-bold" style={css.title}>
            {translate(TKeys.Dashboard.unit)}
            {clearBtn}
            {hasSearch && (
              <SearchInput onSearch={setTextsearch} searchTxt={textSearch} />
            )}
          </div>
        </Col>
      </Row>
      <Row className="pop-over-container-choices">{content()}</Row>
    </div>
  )
}

const css: any = {
  page: {
    width: '296px',
    height: 'auto',
    padding: '25px 24px',
  },
  title: {
    textAlign: 'left',
    color: 'black',
    fontSize: '20px',
    marginBottom: '25px',
  },
  cancel: {
    float: 'right',
    color: '#003168',
    fontSize: '18px',
  },
}

export default UnitContent
